// api接口定义

import auth from "./auth";
import user from "./user";
import sms from "./sms";
import email from "./email";
import common from "./common";
import experiment from "./experiment";
import storage from "./storage";
import news from "./news";
import allianceSchool from "./allianceSchool";


export default {
    auth,
    user,
    email,
    sms,
    common,
    storage,
    experiment,
    news,
    allianceSchool
}